// Customizable Area Start
Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.userName = "User name"
exports.location = "Location"
exports.url = "Location"
exports.educationList = "/profile/educational_qualifications"
exports.projectList = "/profile/projects"
exports.awardList = "/profile/awards"
exports.patentList = "/profile/publication_patents"

exports.educationalTitle = "Educational Qualification";
exports.projectLabel = "Project";
exports.awardsLabel = "Awards";
exports.publicationPatentLabel = "Publication Patents";
exports.showMore = "Show More";
exports.noProjectText = "No project...";
exports.noQualiText = "No qualifications";
exports.noAwards = "No Award...";
exports.noPublicationPatents = "No Publication Patents...";
exports.closeText = "Close";

exports.getEducationContentType = "application/json";
exports.getEducationApiMethod = "GET";
exports.getEducationApiEndPoint = "profile/educational_qualifications";

exports.getProjectContextType = "application/json";
exports.getProjectApiMethod = "GET";
exports.getProjectApiEndPoint = "profile/projects";

exports.getAwardsContextType = "application/json";
exports.getAwardsApiMethod = "GET";
exports.getAwardsApiEndPoint = "profile/awards";

exports.getPatentsContextType = "application/json";
exports.getPatentsApiMethod = "GET";
exports.getPatentsApiEndPoint = "profile/publication_patents";
// Customizable Area End